import { useQuery } from '@tanstack/react-query';
import Loader from '__components/Kizen/Loader';
import BasicModal from '__components/Modals/presets/BasicModal';
import { createSetupIntentQuery } from 'query/billing';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useMemo } from 'react';
import { SetupForm } from './SetupForm';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { Typography } from '@kizen/kds/Typography';
import { useHistory } from 'react-router-dom';
import { grayScale } from '__app/colors';

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export const AddCardModal = (props: any) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { data, isLoading, error } = useQuery(
    createSetupIntentQuery({
      gcTime: 0,
      enabled: props.show,
      throwOnError: false,
      retry: false,
    })
  );

  const isAddressError = (error as AxiosError)?.response?.status === 400;

  const stripeOptions = useMemo(() => {
    if (!data) {
      return;
    }

    return {
      appearance: {
        variables: {
          colorText: grayScale.dark,
          // colorTextSecondary: grayScale.dark,
          fontSizeBase: '14px',
        },
      },
      clientSecret: data?.client_secret,
    };
  }, [data]);

  if (isAddressError) {
    return (
      <BasicModal
        {...props}
        size="small"
        heading={t('Business Address Required')}
        buttonText={t('Add Address')}
        onConfirm={() => {
          history.push('/settings/business');
        }}
      >
        <div className="pb-2">
          <Typography>
            {t(
              'In order to add a payment method, please add your business address first and try again.'
            )}
          </Typography>
        </div>
      </BasicModal>
    );
  }

  return (
    <BasicModal
      {...props}
      hideFooter
      size="large"
      heading={t('Add Payment Method')}
    >
      {isLoading || !stripeOptions ? (
        <div className="min-h-[188px] flex items-center justify-center">
          <Loader loading paddingTop="0" />
        </div>
      ) : (
        <Elements stripe={stripePromise} options={stripeOptions}>
          <SetupForm onCancel={props.onHide} />
        </Elements>
      )}
    </BasicModal>
  );
};
